/* ============================================================================
 * Movatic WMS — Frontend | CesarFilho 932048016
 * Arquivo: src/components/ui/dialog.tsx
 * Diálogo simplificado (sem portal). Suficiente p/ compilar e usar.
 * ========================================================================== */
import * as React from "react";

export type DialogProps = { open?: boolean; onOpenChange?: (v: boolean) => void; children?: React.ReactNode };

export const Dialog = ({ open = false, children }: DialogProps) => (open ? <div>{children}</div> : null);

export const DialogContent = ({ className = "", ...p }: React.HTMLAttributes<HTMLDivElement>) => (
    <div
        className={`fixed inset-0 z-50 grid place-items-center bg-black/50 p-4`}
        role="dialog"
        aria-modal="true"
    >
        <div className={`w-full max-w-xl rounded-lg border border-slate-700 bg-[#0b0f1a] p-4 ${className}`} {...p} />
    </div>
);

export const DialogHeader = (p: React.HTMLAttributes<HTMLDivElement>) => <div className="mb-2" {...p} />;
export const DialogTitle = (p: React.HTMLAttributes<HTMLHeadingElement>) => (
    <h3 className="text-lg font-semibold text-white" {...p} />
);
export const DialogFooter = (p: React.HTMLAttributes<HTMLDivElement>) => <div className="mt-3 flex gap-2" {...p} />;

export default Dialog;
